import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { ProductOptionRoutingModule } from '@business/product-option/product-option-routing.module';
import { ProductOptionPageComponent } from './components/product-option-page/product-option-page.component';

@NgModule({
  imports: [CommonModule, SharedModule, ProductOptionRoutingModule],
  declarations: [ProductOptionPageComponent],
})
export class ProductOptionModule {}
